import { DateTime } from 'luxon';

/**
 * Нормализует ISO дату, устанавливая время на 12:00:00.000
 * Используется для унификации времени при сохранении логов.
 */
export const normalizeToNoon = (isoDate: string): string => {
  const normalized = DateTime.fromISO(isoDate)
    .set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
    .toISO();

  if (normalized) {
    return normalized;
  }

  // Fallback на текущую дату, если парсинг не удался
  return DateTime.local().set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toISO()!;
};

/**
 * Нормализует ISO дату, устанавливая конкретное время из строки "HH:mm".
 * Используется для логов из календаря с указанием времени начала.
 */
export const normalizeToTime = (isoDate: string, time: string): string => {
  const [hours, minutes] = time.split(':').map(Number);

  const normalized = DateTime.fromISO(isoDate)
    .set({ hour: hours, minute: minutes, second: 0, millisecond: 0 })
    .toISO();

  if (normalized) {
    return normalized;
  }

  return normalizeToNoon(isoDate);
};
